import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, Award } from "lucide-react";

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="pt-32 pb-20 px-4 sm:px-6 bg-gradient-to-br from-slate-50 to-emerald-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6 sm:space-y-8">
            <div className="inline-flex items-center gap-2 bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-semibold">
              <Award className="w-4 h-4" />
              Since 2008
            </div>
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-slate-900 leading-tight">
              Driving Growth Through
              <span className="text-emerald-600"> Search Visibility</span>
            </h1>
            <p className="text-lg sm:text-xl text-slate-600 leading-relaxed">
              I help businesses grow through SEO, AI-powered marketing, and video content that attracts attention and drives results.
            </p>
            <div className="flex flex-wrap gap-4">
              <Button
                onClick={() => scrollToSection("contact")}
                size="lg"
                className="bg-emerald-600 hover:bg-emerald-700 text-white transition-all duration-200 hover:shadow-lg hover:scale-105"
              >
                Start Your Growth Journey
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <Button
                onClick={() => scrollToSection("services")}
                size="lg"
                variant="outline"
                className="border-slate-300 text-slate-700 hover:border-emerald-600 hover:text-emerald-600 transition-all duration-200"
              >
                Explore Services
              </Button>
            </div>
          </div>
          <div className="flex flex-col items-center gap-6">
            <div className="relative">
              <div className="absolute inset-0 bg-emerald-500/20 rounded-full blur-3xl"></div>
              <img
                src="https://customer-assets.emergentagent.com/job_1ecab08a-ecd5-45c7-9d6f-5c45ef1c60d4/artifacts/4p38vz5l_Photo%20profile%20Raffi%20Lakhdar.jpg"
                alt="Raffi Lakhdar"
                className="relative w-64 h-64 sm:w-80 sm:h-80 rounded-full object-cover shadow-2xl border-4 border-white"
              />
            </div>
            <div className="text-center">
              <h2 className="text-2xl sm:text-3xl font-bold text-slate-900">
                Raffi Lakhdar
              </h2>
              <p className="text-emerald-600 font-medium mt-1">
                SEO Expert & Digital Strategist
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;